import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/layouts/mainLayout';
import RegistrationFormModal from '../../components/modals/registreModal';
import LoginFormModal from '../../components/modals/loginModal';
import dashboardImage from '../../assets/images/dashboard.png';
import posBillingImage from '../../assets/images/billing.png';
import transactionsImage from '../../assets/images/transactions.png';
import reportsImage from '../../assets/images/reports.png';
import invoice from '../../assets/images/invoice.png'
import ForgotPasswordModal from '../../components/modals/forgotPassModal';
import HeroSection from '../../components/heroSection';
import Features from '../../components/featureSection';
import ContactUs from '../../components/contactUs';
import SummarySection from '../../components/summary';

const Home = () => {
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
    const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);

    const toggleLoginModal = () => {
        setLoginModalOpen(!isLoginModalOpen);
    };

    const toggleRegisterModal = () => {
        setRegisterModalOpen(!isRegisterModalOpen);
    };

    useEffect(() => {
        if (isLoginModalOpen || isRegisterModalOpen || isForgotPasswordModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isLoginModalOpen, isRegisterModalOpen, isForgotPasswordModalOpen]);


    return (
        <MainLayout>
            <HeroSection />
            <Features />
            <SummarySection />
            {/* Free Trial Section */}
            <div className=" text-white py-16 px-4"
                style={{
                    background: `linear-gradient(to left, ${"#336a71"}, ${"#54a7b2"})`,
                }}>
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl font-bold mb-4">Start Your Free Trial Today</h2>
                    <p className="text-lg mb-8">Sign up now and enjoy all features free for 5 days. No credit card required!</p>
                    <button
                        onClick={toggleRegisterModal}
                        className="bg-white text-primary px-8 py-3 rounded-lg shadow-lg hover:bg-gray-100 transition duration-200 text-lg font-medium"
                    >
                        Get Started
                    </button>
                </div>
            </div>

            <ContactUs />
            {/* Modals */}
            <RegistrationFormModal isOpen={isRegisterModalOpen} onClose={() => setRegisterModalOpen(!isRegisterModalOpen)} toggleModal={toggleRegisterModal} />
            {isLoginModalOpen && <LoginFormModal toggleModal={toggleLoginModal} openForgotPasswordModal={() => setForgotPasswordModalOpen(true)} />}
            {isForgotPasswordModalOpen && (
                <ForgotPasswordModal
                    toggleModal={() => setForgotPasswordModalOpen(false)}
                />
            )}
        </MainLayout>
    );
};

export default Home;
